import type { Flow } from '@/types/flow-config-type.ts'
import { FlowTypes } from '@logistiek-zonder-papier/lzp-library'

export const defaultFlows: Flow[] = [
  {
    type: FlowTypes.registration,
    label: 'Registreer',
    description: 'Registreer voor een sub-app',
  },
  {
    type: FlowTypes.load,
    label: 'Laden',
    description: 'Het laden van producten.',
  },
  {
    type: FlowTypes.unload,
    label: 'Lossen',
    description: 'Het lossen van producten.',
  },
] as const
